<template>

    <div
      class="flex flex-col items-stretch justify-between bg-white dark:bg-bs-dark-bg-over rounded-3xl tip-item p-3 xl:p-5 3xl:p-3 relative mt-4 mb-4"
    >
      <div class="flag-container">
        <div class="flex">
        <div
          class="rounded-full ml-8 -mb-5 w-12 h-12 flag-holder overflow-hidden border-4 border-bs-gray-light dark:border-bs-dark-bg"
        >
          <img
            v-if="flag"
            :src="`/img/countries/${flag}.svg`"
            :alt="`Country ${country} Flag`"
          />
          <img v-else :alt="`Country ${country}`" src="/img/countries/globe.svg" />
        </div>
        <p class="date-text text-bs-gray-dark mt-2 ml-2 dark:text-white">{{ competition }}</p>
      </div>
      </div>
      <!-- H2H toggle -->
      <div class="-mt-12 ml-auto h-12">
        <Button
          v-if="preGameStats && !skipH2H"
          class="-z-10 text-xs bg-white dark:bg-bs-dark-bg-over text-bs-gray-dark opacity-70 dark:text-white rounded-lg p-3 pt-2 pb-6 h-12 "
          @click.prevent="showH2H = !showH2H"
          >{{ showH2H ? "H2H ▲" : "H2H ▼" }}</Button
        >
      </div>
      
      <div v-if="isLive" class="live-badge">
        <span class="live-dot"></span> LIVE {{ liveMinute }}'
      </div>
      <div class="flex items-center justify-start mt-6 mb-2">
          <div :class="['score ml-1 mr-2 w-6', isLive ? 'score-live' : '']">
            <h3 class="gradient-text">{{ displayHomeGoals }}</h3>
          </div>
           <span
              class="text-sm 2xl:text-lg block text-bs-gray-dark dark:text-white font-medium text-right 3xl:text-xs"
              >{{ homeTeam }}</span
            >
      </div>
      <div class=" flex items-center justify-start mb-2">
          <div :class="['score ml-1 mr-2 w-6', isLive ? 'score-live' : '']">
            <h3 class="gradient-text">{{ displayAwayGoals }}</h3>
          </div>
           <span
              class="text-sm 2xl:text-lg block text-bs-gray-dark dark:text-white font-medium text-right 3xl:text-xs"
              >{{ awayTeam }}</span
            >
      </div>

      <div class="dashed-separator h-4 my-2 -mx-6" />
      
      <div class="flex justify-between bg-bs-gray-light rounded-lg mt-4 dark:bg-bs-gray-dark p-3" v-if="confidence">
        <span class="text-bs-gray-dark dark:text-white">Confidence</span>
        <span class="ml-auto">{{new Array(confidence + 1).join('⭐')}}</span>
      </div>

      <div
        v-if="statusClass === 'is-pending'"
        class="w-full is-pending bg-bs-gray-light dark:bg-bs-gray-dark mt-2"
      />
      <div
        class="flex justify-between bg-bs-gray-light rounded-lg mt-2 dark:bg-bs-gray-dark"
      >
        <span
          v-for="s in statuses"
          :key="s.key"
          :class="
            s.key === statusClass
              ? 'status selected-status ' + statusClass
              : 'status dark:text-white'
          "
          >{{ s.label }}</span
        >
      </div>
      
      <div class="flex mt-4 items-center">
        <div
          class="rounded-full mr-4 ml-2 w-12 h-12  overflow-hidden bg-bs-gray-light dark:bg-bs-dark-bg"
        >
          <img
            :src="teamLogo"
            :alt="teamName"
          />
          </div>
          <div class="text-left">
            <p class="text-sm text-bs-gray-dark dark:text-white">Tipped by {{ teamName }}</p>
            <p class="date-text text-bs-gray-dark dark:text-white opacity-60">{{ formattedDate }}</p>
          </div>
      </div>

      <h-2-h
        class="h2h"
        v-if="preGameStats && showH2H"
        :homeData="preGameStats.homeData"
        :awayData="preGameStats.awayData"
      />
    </div>
  
</template>

<script>
import flags from "../../assets/flags.json";
import H2H from "./H2H.vue";
import { mapGetters } from "vuex";
export default {
  props: [
    "homeTeam",
    "homeGoals",
    "awayTeam",
    "awayGoals",
    "statusLabel",
    "formattedDate",
    "teamName",
    "teamLogo",
    "statusClass",
    "country",
    "competition",
    "confidence",
    "preGameStats",
    "skipH2H",
    "eventId"
  ],
  components: {
    H2H,
  },
  data: function () {
    return {
      showH2H: false,
      statuses: [
        { label: "Loss", key: "is-loss" },
        { label: "Half Loss", key: "is-half-loss" },
        { label: "Void", key: "is-void" },
        { label: "Half Win", key: "is-half-win" },
        { label: "Win", key: "is-win" },
      ],
    };
  },
  computed: {
    ...mapGetters(["getLiveData"]),
    flag: function () {
      if (this.country && flags[this.country.toLowerCase()]) {
        return this.country.toLowerCase();
      } else {
        return false;
      }
    },
    live: function () {
      return this.eventId ? this.getLiveData(this.eventId) : null;
    },
    isLive: function () {
      return this.live && this.statusClass === "is-pending";
    },
    displayHomeGoals: function () {
      return this.isLive ? (this.live.homeGoals ?? this.homeGoals) : this.homeGoals;
    },
    displayAwayGoals: function () {
      return this.isLive ? (this.live.awayGoals ?? this.awayGoals) : this.awayGoals;
    },
    liveMinute: function () {
      return this.live ? this.live.minute : "";
    },
  },
  methods: {},
};
</script>

<style>
.flag-container {
  top:-1.5rem;
  left:-0.5rem;
  width: 100%;
  position:absolute;
  
}
.score {
  @apply relative flex items-center justify-center text-xl text-bs-yellow bg-bs-gray-light font-medium dark:bg-bs-dark-bg py-1 px-1 rounded w-10 h-8 text-center mb-1;
  border-top-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.score.score-right {
  border-top-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.score:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
}
.score h3 {
  /* font-family: 'Orbitron', sans-serif; */
  @apply font-bold;
}
.flag-holder {
  position: relative;
}
.flag-holder:after {
  position: absolute;
  width: 100%;
  height: 100%;
  content: "";
  top: 0;
  left: 0;
  border-radius: 100%;
  box-shadow: inset -47px 0px 0 -35px rgba(0, 0, 0, 0.1);
}
.flag-holder img {
  width: 100%;
  height: 100%;
  z-index: -1;
}
.teams {
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  grid-template-rows: 50px 1fr;
  align-items: center;
  overflow: hidden;
}

/** to remove **/
.flag-and-teams {
  display: grid;
  grid-template-columns: 1fr 60px;

  width: 100%;
  padding: 0;
}
.tip-item {
  box-shadow: 0px 7px 14px #dde2ef;
}
.dark .tip-item {
  box-shadow: 0px 7px 14px rgba(0, 0, 0, 0.1);
}
.status {
  @apply text-xs px-2 m-1 py-2 text-bs-gray-dark whitespace-nowrap;

  @screen lg {
    @apply px-3;
  }
}
.date-text {
  font-size: 0.6rem;
}

.selected-status {
  @apply text-white rounded-lg;
}
.is-win {
  background: linear-gradient(301.65deg, #1d9c2a 27.38%, #6be475 97.67%);
}

.is-loss {
  background: linear-gradient(294.18deg, #e50000 31.8%, #ffa7a7 109.71%);
}
.is-void {
  background: linear-gradient(303.37deg, #e5680c 27.95%, #fbd6bc 96.46%);
}
.is-half-win {
  background: linear-gradient(301.65deg, #87c88d 27.38%, #daffdd 97.67%);
}
.is-half-loss {
  background: linear-gradient(298.74deg, #fc6767 28.75%, #ffa7a7 102.13%);
}

@keyframes wobblebar-loader {
  0% {
    left: -60%;
  }
  100% {
    left: 100%;
  }
}
/* :not(:required) hides this rule from IE9 and below */
.is-pending:not(:required) {
  @apply w-full;
  border-radius: 10.66667px;
  display: inline-block;
  overflow: hidden;
  text-indent: -9999px;

  height: 0.6rem;
  position: relative;
}
.is-pending:not(:required)::after {
  @apply bg-bs-yellow;
  animation: wobblebar-loader 1.2s infinite linear;
  display: block;
  -moz-border-radius: 7.11111px;
  -webkit-border-radius: 7.11111px;
  border-radius: 7.11111px;
  content: "";
  position: absolute;
  top: 0.1rem;
  left: 4px;
  width: 60%;
  height: 0.4rem;
}
.live-badge {
  @apply absolute top-3 right-3 text-xs font-bold text-white px-3 py-1 rounded-full;
  background: linear-gradient(135deg, #e50000, #ff4444);
  animation: live-pulse 2s infinite;
  z-index: 10;
}
.live-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
}
.score-live {
  @apply bg-green-100 dark:bg-green-900;
}
@keyframes live-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}
.dashed-separator {
  background-image: linear-gradient(to right, #F4F6FA 51%, rgba(255,255,255,0) 0%);
  background-position: bottom;
  background-size: 10px 4px;
  background-repeat: repeat-x;

}
.dark .dashed-separator {
  background-image: linear-gradient(to right, #07255B 51%, rgba(255,255,255,0) 0%);

}
</style>
